<template>
	<div ref="calculationCreate" class="full-container">
		<div class="full-top-wrap">
			Calculation Create
		</div>
		<div class="full-center-wrap" style="overflow-y: scroll;">
			<form @submit.prevent="doValidation()">
				<p class="txt-crud-title">
					Calculation Form
				</p>
				<p class="txt-form-title">
					Calculation Info
				</p>
				<!-- Validation Info -->
				<table class="tb-crud-horizon">
					<colgroup>
						<col width="11%" />
						<col width="39%" />
						<col width="11%" />
						<col width="39%" />
					</colgroup>
					<tbody>
						<tr>
							<th>Calculation Field</th>
							<td colspan="2">
								<div style="position: relative; width:100%; height: 32px;">
									<div
										class="drop-list"
										:class="errors.has('calculationField') ? 'input-crud-error' : ''"
										:title="
											(
												!utils.isEmpty(calculateForm.calculateName) ?
												calculateForm.calculateName :
												'Please select the field'
											)
										"
										:style="!utils.isEmpty(calculateForm.calculateName) ? {color: '#999'} : {}"
										@click="openDropList('calculationField', $event);"
									>
										{{
											(
												!utils.isEmpty(calculateForm.calculateName) ?
												calculateForm.calculateName :
												"Please select the field"
											)
										}}
									</div>
									<DropList
										v-if="openDropIndex == 'calculationField'"
										v-model="calculateForm.value"
										:validVisitList="calcVisitList"
										:fieldTypeList="fieldTypeList"
										@input="setMainDropValue(calculateForm)"
									/>
									<input
										type="hidden"
										:name="'calculationField'"
										v-model="calculateForm.value"
										v-validate="'required'"
										data-vv-as="Target Field"
									/>
								</div>
								<p v-if="isDuplicate" class="txt-validation">
									* Calculation Field is duplicated.
								</p>
							</td>
						</tr>
						
						<tr>
							<th>Register</th>
							<td>
								{{ item.firstRegistUserId }}
							</td>
							<th>Regist Date</th>
							<td>
								{{ item.firstRegistDate }}
							</td>
						</tr>
						<tr>
								<th>Conditional Formula</th>
								<td colspan="3" style="padding: 15px 10px;">
									<!-- Validation Condition Group List -->
									<p class="txt-form-stitle" style="margin-top: 0; padding: 0;">
										Group List
										<button
											type="button"
											title="Add Group"
											class="btn-new"
											style="margin: 0;"
											@click="addCalculateGroupForm(calculateForm.calculateGroupList.length)"
										>
											Add Group
										</button>
									</p>
									<!-- Calculate Condition Group Form -->
									<template v-for="(con, conIndex) in calculateForm.calculateGroupList">
										<template v-if="conIndex != 0">
											<div v-if="conIndex != 0"
												:key="'calculateGroup'+con.groupSortOrder"
												class="con-group-wrap"
											>
												<p class="con-operator-title" style="display: flex; align-items: center; justify-content: space-between; width:35%; margin:0">
													Group Operator
													<select
														v-if="conIndex != 0"
														class="select-cal-crud"
														:name="conIndex + '_operatorCd'"
														:class="errors.has(conIndex + '_operatorCd') ? 'input-crud-error' : ''"
														v-model="calculateForm.calculateGroupList[conIndex-1].groupOperator"
														v-validate="'required'"
														:data-vv-as="conIndex + '_operatorCd'"
														:style="(con.groupOperator == '' ? {width: '250px', color: '#ccc'} : {width: '250px'})"
														@change="setInput()"
													>
														<option value="" disabled hidden>
															Operator
														</option>
														<option value="+"> + </option>
														<option value="-"> - </option>
														<option value="*"> * </option>
														<option value="/"> / </option>
													</select>
												</p>
											</div>
										</template>
										<div
											:key="'conGroup' + conIndex"
											class="con-group-wrap"
										>
											<!-- Validation Condition Detail List -->
											<p class="con-group-title">
												Group {{ conIndex + 1 }}
												<button
													type="button"
													title="Remove Group"
													class="btn-small-remove"
													style="margin: 0;"
													@click="removeCalculateGroupForm(conIndex)"
												></button>
											</p>
											<input
												type="text"
												class="input-crud"
												v-model="con.text"
												readonly
											/>
											<!-- Calculate Condition Detail Form -->
											<div
												v-for="(conDetail, conDetailIndex) in con.calculateDetailList"
												:key="conDetailIndex"
												class="con-detail-wrap"
											>
												<!-- Validation Condition Detail Select Field -->
												<div class="label">
													<p>
														<button
															type="button"
															class="select-field-value"
															:class="conDetail.fieldTypeCd == 'FIELD' ? 'selected-field-value' : ''"
															@click="setFieldTypeCd(conIndex, conDetailIndex, 'FIELD')" 
														>
															Field
														</button>
														or
														<button
															type="button"
															class="select-field-value"
															:class="conDetail.fieldTypeCd == 'VALUE' ? 'selected-field-value' : ''"
															@click="setFieldTypeCd(conIndex, conDetailIndex, 'VALUE')"
														>
															Value
														</button>
														or
														<button
															type="button"
															class="select-field-value"
															:class="conDetail.fieldTypeCd == 'FUNCTION' ? 'selected-field-value' : ''"
															@click.stop="openFunctionModal(conIndex, conDetailIndex, conDetail.funcParamList)"
														>
															Function
														</button>
													</p>
													<div 
														v-if="conDetail.fieldTypeCd == 'FIELD'"
														style="position: relative; width:100%; height: 32px;"
													>
														<div
															class="drop-list"
															:class="errors.has(conIndex + '_' + conDetailIndex + '_targetField') ? 'input-crud-error' : ''"
															:title="
																(
																	!utils.isEmpty(conDetail.calculateDetailName) ?
																	conDetail.calculateDetailName :
																	'Please select the field'
																)
															"
															:style="!utils.isEmpty(conDetail.calculateDetailName) ? {color: '#999'} : {}"
															@click="openDropList(conIndex + '_' + conDetailIndex + '_targetField', $event);"
														>
															{{
																(
																	!utils.isEmpty(conDetail.calculateDetailName) ?
																	conDetail.calculateDetailName :
																	"Please select the field"
																)
															}}
														</div>
														<DropList
															v-if="openDropIndex == conIndex + '_' + conDetailIndex + '_targetField'"
															v-model="conDetail.value"
															:validVisitList="validVisitList"
															:fieldTypeList="fieldTypeList"
															@input="setDropValue(conDetail)"
														/>
														<input
															type="hidden"
															:name="conIndex + '_' + conDetailIndex + '_targetField'"
															v-model="conDetail.value"
															v-validate="'required'"
															data-vv-as="Target Field"
														/>
													</div>
													<input
														v-if="conDetail.fieldTypeCd == 'VALUE'"
														type="number"
														class="input-crud"
														:name="conIndex + '_' + conDetailIndex + '_fieldValue'"
														:class="errors.has(conIndex + '_' + conDetailIndex + '_fieldValue') ? 'input-crud-error' : ''"
														v-model="conDetail.fieldValue"
														v-validate="'required'"
														data-vv-as="Field Value"
														placeholder="Please enter the compare value."
														@change="setInput()"
													/>
													<div
														v-if="conDetail.fieldTypeCd == 'FUNCTION'"
														class="input-crud"
														:name="conIndex + '_' + conDetailIndex + '_functionValue'"
														:class="errors.has(conIndex + '_' + conDetailIndex + '_functionValue') ? 'input-crud-error' : ''"
														data-vv-as="Function Value"
														disabled
														style="display: flex; align-items: center;"
													>
														{{conDetail.calculateDetailName}}
													</div>
												</div>
												<label>
													<p>
														Operator
													</p>
													<select
														v-if="(conDetailIndex + 1) != con.calculateDetailList.length"
														class="select-cal-crud"
														:name="conIndex + '_' + conDetailIndex + '_operatorCd'"
														:class="errors.has(conIndex + '_' + conDetailIndex + '_operatorCd') ? 'input-crud-error' : ''"
														v-model="conDetail.fieldOperator"
														v-validate="'required'"
														:data-vv-as="conIndex + '_' + conDetailIndex + '_operatorCd'"
														:style="(conDetail.fieldOperator == '' ? {color: '#ccc'} : {})"
														@change="setInput()"
													>
														<option value="" disabled hidden>
															Operator
														</option>
														<option value="+"> + </option>
														<option value="-"> - </option>
														<option value="*"> * </option>
														<option value="/"> / </option>
													</select>
													<select
														v-if="(conDetailIndex + 1) == con.calculateDetailList.length"
														class="select-cal-crud"
														:name="conIndex + '_' + conDetailIndex + '_operatorCd'"
														v-model="conDetail.fieldOperator"
														:data-vv-as="conIndex + '_' + conDetailIndex + '_operatorCd'"
														:style="(conDetail.fieldOperator == '' ? {color: '#ccc'} : {})"
														disabled
													>
														<option value="" disabled hidden>
															Operator
														</option>
														<option value="+"> + </option>
														<option value="-"> - </option>
														<option value="*"> * </option>
														<option value="/"> / </option>
													</select>
												</label>
												<!-- Validation Condition Detail Target Field -->
												<!-- Validation Condition Detail Logical Operator -->
												
												<!-- Validation Condition Detail Last Row None Logical Operator -->
												<!-- Validation Condition Detail Last Row Add or Remove -->
												<button
													v-if="conDetailIndex == 0"
													type="button"
													class="btn-add-row"
													title="Add Row"
													@click.stop="addCalculateDetailForm(conIndex)"
												></button>
												<button
													v-if="conDetailIndex != 0"
													type="button"
													class="btn-remove-row"
													title="Remove Row"
													@click.stop="removeCalculateDetailForm(conIndex, conDetailIndex)"
												></button>
											</div>
										</div>
									</template>
								</td>
							</tr>
							<tr>
								<th>Summary</th>
								<td colspan="2">
									<input
										type="text"
										class="input-crud"
										v-model="calculateForm.allText"
										readonly
									/>
								</td>
							</tr>
					</tbody>
				</table>
				<!-- Validation List -->
			</form>
		</div>
		<div class="full-bottom-wrap">
			<button v-if="workAccessCheck('CREATE') && !(projectStateCd == '4' || projectStateCd == '3')" type="button" class="btn-save fright" title="Save" @click.stop="doValidation()">
				Save
			</button>
			<button type="button" class="btn-cancel fright" title="Cancel" @click.stop="doCancel()">
				Cancel
			</button>
		</div>
		<FuncModal :funcModalParam="funcModalParam" />
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import DropList from "@/components/project/validation/DropList.vue";
import FuncModal from "@/components/project/calculation/FuncModal.vue";

export default {
	name: "CalculationCreate",
	created() {
		this.logger.debug(this, "created()");

		this.item.projectNo = this.$route.params.projectNo;
		this.item.firstRegistDate = moment().format("YYYY-MM-DD");
		this.item.firstRegistUserId = sessionStorage.userName + " (" + sessionStorage.userId + ")";

		this.selectVisitList();
		this.selectValidVisitList();
		this.selectCalcVisitList();
		this.selectFieldTypeCdList();
		this.getAccessList('CALCULATION');
		this.getProjectStateCd();

		// 로딩바 종료
		this.$nextTick(function () {
			setTimeout(function() {
				EventBus.$emit("project-loading", false);
			}.bind(this), 400);
		});

		EventBus.$on("blurDropList", () => {
			this.logger.debug(this, "[EventBus] blurDropList");
			this.openDropIndex = "";
		});
	},
	components: {
		DropList,
		FuncModal
	},
	data() {
		return {
			// 조회 및 로드를 위한 데이터
			item: {},
			visitList: [],
			resultTypeList: [],
			validVisitList: [],
			calcVisitList: [],
			operatorList: [],
			groupOperatorList: [],
			pageList: [],
			calculateList: [],
			fieldTypeList: [],
			openDropIndex: "",
			funcModalParam: {},
			// 입력, 수정을 위한 데이터
			calculateForm: {
				projectNo: this.$route.params.projectNo,
				calculateName:"",
				calculateType:"NUMBER",
				visitNo: "",
				pageNo: "",
				procNo: "",
				procQuestionNo: "",
				procFieldNo: "",
				useYn: "Y",
				// Calculate 상세 리스트
				calculateGroupList: [
					{
						groupSortOrder: 1,
						groupOperator: "",
						text: "",
						// 그룹 조건식 상세 리스트
						calculateDetailList: [
							{
								calculateDetailName:"",
								visitNo: "",
								pageNo: "",
								procNo: "",
								procQuestionNo: "",
								procFieldNo: "",
								fieldTypeCd: "FIELD",
								fieldValue: "",
								fieldOperator: "",
								fieldSortOrder: 1,
								fieldChildName:"",
								funcParamList: [],
							}
						]
					}
				]
			},
			calculateGroupForm: {
				groupSortOrder: 1,
				groupOperator: "",
				text: "",
				calculateDetailList: []
			},
			calculateDetailForm: {
				calculateDetailName:"",
				visitNo: "",
				pageNo: "",
				procNo: "",
				procQuestionNo: "",
				procFieldNo: "",
				fieldTypeCd: "FIELD",
				fieldValue: "",
				fieldOperator: "",
				fieldSortOrder: 1,
				fieldChildName:"",
				funcParamList: [],
			},
			isDuplicate: false,
			accessList: [],
			projectStateCd: ""
		};
	},
	watch: {
		'calculateForm.calculateName' : function(){
			this.selectDuplicateCheck();
		}
	},
	methods: {
		// 초기 조회 기능 시작
		selectVisitList() {
			this.logger.debug(this, "selectVisitList()");
			axios
				.post(this.config.contextRoot + "/visit/selectList.do", this.item)
				.then((response) => {
					console.log(response);
					this.visitList = response.data.visitList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectValidVisitList() {
			this.logger.debug(this, "selectValidVisitList()");
			axios
				.post(this.config.contextRoot + "/valid/selectValidVisitList.do", this.item)
				.then((response) => {
					console.log(response);
					this.validVisitList = response.data.validVisitList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectCalcVisitList() {
			this.logger.debug(this, "selectCalcVisitList()");
			axios
				.post(this.config.contextRoot + "/calculate/selectCalcVisitList.do", this.item)
				.then((response) => {
					console.log(response);
					this.calcVisitList = response.data.calcVisitList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectPageList(visitNo, category) {
			this.logger.debug(this, "selectPageList()"+visitNo+category);
			axios
				.post(this.config.contextRoot + "/calculate/selectVisitPageList.do", {visitNo: visitNo, searchCategory: category})
				.then((response) => {
					console.log(response);
					if(category == 'calculate')
					{
						this.pageList = response.data.pageList;
					}
					else
					{
						this.calculateList = response.data.calculateList;
					}
					
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectFieldTypeCdList() {
			this.logger.debug(this, "selectOperatorCdList()");
			axios
				.post(this.config.contextRoot + "/common/code/selectComCodeList.do", {classCode: "FIELD_TYPE_CD"})
				.then((response) => {
					console.log(response);
					this.fieldTypeList = response.data.codeList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		setMainDropValue(obj) {
			obj.visitNo = obj.value.visitNo;
			obj.pageNo = obj.value.pageNo;
			obj.procNo = obj.value.procNo;
			obj.procQuestionNo = obj.value.procQuestionNo;
			obj.procFieldNo = obj.value.procFieldNo;
			obj.calculateName = obj.value.valueText;
		},
		setDropValue(obj, isTarget) {
			if(!isTarget){
				obj.visitNo = obj.value.visitNo;
				obj.pageNo = obj.value.pageNo;
				obj.procNo = obj.value.procNo;
				obj.procQuestionNo = obj.value.procQuestionNo;
				obj.procFieldNo = obj.value.procFieldNo;
				obj.fieldChildName = obj.value.fieldChildName;
				obj.calculateDetailName = obj.value.valueText;
			}
			else
			{
				obj.targetVisitNo = this.calculateForm.visitNo;
				obj.targetPageNo = obj.targetValue.pageNo;
				obj.targetProcNo = obj.targetValue.procNo;
				obj.targetProcQuestionNo = obj.targetValue.procQuestionNo;
				obj.targetProcFieldNo = obj.targetValue.procFieldNo;
			}
			this.setInput();
		},
		setInput(){
			for(let i=0; i<this.calculateForm.calculateGroupList.length; i++)
			{
				let putData = "";
				for(let j=0; j<this.calculateForm.calculateGroupList[i].calculateDetailList.length; j++)
				{
					if(this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldTypeCd == "FIELD")
					{
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldChildName;
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldOperator;
					}
					else if(this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldTypeCd == "VALUE")
					{
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldValue;
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldOperator;
					}
					else if(this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldTypeCd == "FUNCTION")
					{
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].calculateDetailName;
						putData += this.calculateForm.calculateGroupList[i].calculateDetailList[j].fieldOperator;
					}
				}
				this.calculateForm.calculateGroupList[i].text = putData;
			}

			this.setAllInput();
		},
		setAllInput(){
			let putAllData = "";
			for(let i=0; i<this.calculateForm.calculateGroupList.length; i++)
			{
				putAllData += " ("+this.calculateForm.calculateGroupList[i].text+") ";
				putAllData += this.calculateForm.calculateGroupList[i].groupOperator;
			}
			this.calculateForm.allText = putAllData;
		},
		addCalculateGroupForm(calculateGroupIndex) {
			this.logger.debug(this, "addCalculateGroupForm(calculateGroupIndex)");
			let calculateGroupForm = JSON.parse(JSON.stringify(this.calculateGroupForm));
			let calculateDetailForm = JSON.parse(JSON.stringify(this.calculateDetailForm));

			calculateGroupForm.groupSortOrder = calculateGroupIndex + 1;
			calculateGroupForm.calculateDetailList.push(calculateDetailForm);

			this.calculateForm.calculateGroupList.push(calculateGroupForm);
		},
		removeCalculateGroupForm(calculateGroupIndex) {
			this.logger.debug(this, "removeValidConForm(calculateGroupIndex)");
			if(this.calculateForm.calculateGroupList.length == 1)
			{
				this.$alert("At least one group must exist!", "Warn", "warning");
			}
			else
			{
				if(this.calculateForm.calculateGroupList.length - 1 == calculateGroupIndex){
					this.calculateForm.calculateGroupList[calculateGroupIndex - 1].groupOperator = "";
				}
				this.calculateForm.calculateGroupList.splice(calculateGroupIndex, 1);
			}
			this.setInput();
		},
		setFieldTypeCd(conIndex, conDetailIndex, value) {
			this.logger.debug(this, "setTargetTypeCd(conIndex, conDetailIndex, value)");
			this.$set(this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex], "fieldTypeCd", value);

			let field = this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex];
			if(value != 'FUNCTION'){
				field.funcParamList = [];
				field.calculateDetailName = "";
			}
			if(value == 'FIELD')
			{
				field.fieldValue = "";
			}
			else
			{
				field.calculateDetailName = "";
				field.fieldChildName = "";
				field.procFieldName = "";
				field.value = {};
				field.visitNo = "";
				field.pageNo = "";
				field.procNo = "";
				field.procQuestionNo = "";
				field.procFieldNo = "";
			}
			this.setInput();
		},
		openDropList(index, event) {
			this.openDropIndex = index;

			this.$nextTick(() => {
				event.target.parentNode.children[1].children[0].focus();
			})
		},
		addCalculateDetailForm(calculateDetailIndex) {
			this.logger.debug(this, "addCalculateDetailForm(calculateDetailIndex)");
			let calculateDetailForm = JSON.parse(JSON.stringify(this.calculateDetailForm));

			calculateDetailForm.fieldSortOrder = this.calculateForm.calculateGroupList[calculateDetailIndex].calculateDetailList.length + 1;

			this.calculateForm.calculateGroupList[calculateDetailIndex].calculateDetailList.push(calculateDetailForm);
		},
		removeCalculateDetailForm(calculateGroupIndex, calculateDetailIndex) {
			this.logger.debug(this, "removeValidConDetailForm(validDetailIndex, validConIndex, validConDetailIndex)");
			if(this.calculateForm.calculateGroupList[calculateGroupIndex].calculateDetailList.length == 1)
			{
				this.$alert("At least one row must exist!", "Warn", "warning");
			}
			else
			{
				if(this.calculateForm.calculateGroupList[calculateGroupIndex].calculateDetailList.length-1 == calculateDetailIndex){
					this.calculateForm.calculateGroupList[calculateGroupIndex].calculateDetailList[calculateDetailIndex-1].fieldOperator = "";
				}
				this.calculateForm.calculateGroupList[calculateGroupIndex].calculateDetailList.splice(calculateDetailIndex, 1);
			}
			this.setInput();
		},
		selectDuplicateCheck(){
			this.logger.debug(this, "selectDuplicateCheck()");
			axios
				.post(this.config.contextRoot + "/calculate/selectDuplicateCheck.do", this.calculateForm)
				.then((response) => {
					console.log(response);
					if(response.data.duplicate == 0)
					{
						this.isDuplicate = false;
					}
					else
					{
						this.isDuplicate = true;
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => { 
					this.logger.debug(this, "doValidationResult:" + result);
					if(result && !this.isDuplicate) {
						this.$confirm("Do you want to save the data?", "Question", "question").then(() => {
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert() {
			axios
				.post(this.config.contextRoot + "/calculate/insert.do", this.calculateForm)
				.then((response) => {
					if (response.status == 200) {
						this.$alert("Calculation has been saved successfully.", "Info", "info").then(() => {
							this.doClose();
						});
					} else {
						alert(response.status);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the Calculation registration?", "Info", "info").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.calculationCreate.style.animation = "fadeOutUp 0.4s ease-in-out both";
			setTimeout(function() {
				let url = this.config.contextRoot + "/project/" + this.$route.params.projectNo + "/calculation"
				if (this.$route.path !== url)
				{
					EventBus.$emit("project-loading", true);
					this.$router.push(url);
					location.reload();
				}
			}.bind(this), 400);
		},
		openFunctionModal(conIndex, conDetailIndex, funcParamList) {
			EventBus.$emit("project-loading", true);

			// let field = this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex];
			// field.fieldValue = "";
			// field.calculateDetailName = "";
			// field.fieldChildName = "";
			// field.procFieldName = "";
			// field.value = {};
			// field.visitNo = "";
			// field.pageNo = "";
			// field.procNo = "";
			// field.procQuestionNo = "";
			// field.procFieldNo = "";

			this.funcModalParam = {
				isOpen: true,
				conIndex: conIndex,
				conDetailIndex: conDetailIndex,
				selectFunc: funcParamList,
			};
		},
		closeFunction(){
			this.funcModalParam = {};
		},
		setFunction(FuncParamList, funcName){
			let conIndex = this.funcModalParam.conIndex;
			let conDetailIndex = this.funcModalParam.conDetailIndex;
			this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex].fieldTypeCd = "FUNCTION";
			this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex].funcParamList = JSON.parse(JSON.stringify(FuncParamList));
			this.calculateForm.calculateGroupList[conIndex].calculateDetailList[conDetailIndex].calculateDetailName = this.setFuncName(JSON.parse(JSON.stringify(FuncParamList)), JSON.parse(JSON.stringify(funcName)));

			this.setInput();
			this.closeFunction();
		},
		setFuncName(funcList, funcName){
			let name = funcName;
			name += '(';

			if(funcList.length == 1){
				if(funcList[0].funcParamsCnt == "1"){
					if(Object.keys(funcList[0].field).length != 0){
						name += funcList[0].field.fieldChildName;
					}
					else{
						name += '"' + funcList[0].value + '"';
					}
				}
			}
			if(funcList.length > 1){
				for(let i = 0; i < funcList.length; i++){
					if(Object.keys(funcList[i].field).length != 0){
						name += funcList[i].field.fieldChildName;
					}
					else{
						name += '"' + funcList[i].value + '"';
					}
					if(i != (funcList.length - 1)){
						name += ', '
					}
				}	
			}

			name += ')';
			return name;
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					console.log(response);
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					console.log(response);
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
	}
};
</script>

<style scoped>
.txt-form-title {
	height: 35px;
	line-height: 35px;
	margin: 20px 0 5px;
	padding: 0 10px;
	font-weight: 600;
	font-size: 13pt;
	color: #666;
}

caption,
.txt-form-stitle {
	margin: 20px 0 5px;
	padding: 0 20px;
	font-weight: 600 !important;
	font-size: 11pt !important;
}

.txt-form-stitle {
	height: 35px;
	line-height: 35px;
}

.select-crud {
	padding: 0 10px;
}

.con-group-wrap {
	margin: 10px 0;
	padding: 20px;
	border-radius: 10px;
	background-color: #f5f5f5;
}

.con-group-title {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	height: 25px;
	margin: 0 0 10px;
	font-weight: 600;
	font-size: 11pt;
	color: #2bade0;
	border-bottom: 1px solid #2bade0;
	padding: 10px 0;
}

.con-operator-title {
	height: 25px;
	margin: 0 0 10px;
	font-weight: 600;
	font-size: 11pt;
	color: #2bade0;
}

.btn-small-remove {
	width: 20px;
	height: 20px;
	border: 1px solid #999;
	border-radius: 3px;
	background-color: #fff;
}

.con-detail-wrap {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-top: 15px;
}

.btn-add-row {
	width: 32px;
	height: 32px;
	border-radius: 5px;
	background-color: #2bade0;
}

.btn-remove-row {
	width: 32px;
	height: 32px;
	border-radius: 5px;
	background-color: #c44944;
}

.con-detail-wrap>.label>p {
	margin: 0 0 5px;
	font-weight: 600;
	font-size: 10pt;
}

.select-field-value {
	font-weight: 600;
	font-size: 10pt;
	color: #999;
	text-decoration: underline;
}

.select-field-value:hover {
	color: #666;
}

.selected-field-value {
	color: #2bade0;
}

.con-detail-wrap>.label:nth-child(1) {
	width: 85%;
}

.con-detail-wrap>.label:nth-child(2) {
	width: 45%;
}

.con-detail-wrap>.label:nth-child(3) {
	width: 10%;
}

.con-detail-wrap>.label:nth-child(4) {
	width: 10%;
}

.drop-list {
	display: block;
	position: relative;
	width: 100%;
	height: 32px;
	line-height: 31px;
	padding: 0 30px 0 15px;
	border: 1px solid #ccc;
	background-color: #fff;
	font-size: 10pt;
	color: #ccc;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.btn-cancel {
	margin-right: 10px;
}
</style>